export default __webpack_public_path__ + "static/media/pending-active.bc852be8.svg";